module.exports = __webpack_public_path__ + "img/daumen.f7b7e397.jpg";